import React from "react";
import background from '@/assets/background/background.webp';

const BackgroundLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div
    className="h-screen bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${background})` }}
  >
    {children}
  </div>
);

export default BackgroundLayout;
